$(function() {  
  const GlobalJs = function() {
    const _this = this;
    const $currencySelector = $('#currency');

    let currency;

    this.init = function () {
      currency = _this.getCookie('currency');

      if (currency) {
        return;
      }

      navigator.geolocation.getCurrentPosition(async (position) => {
        if (!position || !position.coords) {
          return;
        }
    
        const key = "AIzaSyANS1XSTHB3WA-K-Le-shD-6u-DtGOc2sc";
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        $.ajax({
          url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat}, ${lng}&result_type=country&key=${key}`,
          type: "GET",
          success: function(r) {
            if (r.results && r.results[0] && r.results[0].address_components && r.results[0].address_components[0]) {
              const c = r.results[0].address_components[0];
              if (c.short_name && c.short_name === 'CA') {
                $currencySelector.val("CAD");
                $currencySelector.trigger('change');
              } else {
                $currencySelector.val("USD");
                $currencySelector.trigger('change');
              }
            }
          },
          error: function(error) {
            console.log("Error...");
            console.log(error);
          },
        });
      });
    }

    this.getCookie = function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    
    this.setCookie = function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    $(document).ready(function() {
      _this.init();

      $currencySelector.change(function(event) {
        console.log(event.target.value);
        currency = event.target.value;
        _this.setCookie('currency', currency, 90);
        this.form.submit();
      });
    });
  }

  new GlobalJs();
});
